import * as Yup from 'yup';
import { messages } from 'app/config/constants';

export const finalDocumentAdmissionSchema = Yup.object({
  lastReceiptDate: Yup.date().required(messages.MANDATORY_FIELD),
});
